import React, { PropsWithChildren } from 'react';
import { useCopyToClipboard } from 'usehooks-ts';
import { useToast } from '~/hooks/toast';
import { Button } from './Theme';

const CopyButton = (props: PropsWithChildren<{ copyText: string }>) => {

    const { copyText, ...rest } = props;
    const { successToast } = useToast();

    const [value, copy] = useCopyToClipboard();


    const handleClipboard = (text: string) => {
        copy(text);
        successToast('Copied to clipboard');
    };

    return (
        // eslint-disable-next-line react/no-children-prop
        <Button modifier={'small'} text={'copy'} {...rest } onPress={() => handleClipboard(copyText)} />
    );
};

export default CopyButton;
